import firebase from '../../Firebase';
import * as dateHelper from '../../utils/data_util';

export function fetchMerchantProductTraceability(merchantUserId, dispatcheId, onSuccess) {
    firebase.firestore().collection('merchant_dispatches').doc(merchantUserId).collection('dispatches').doc(dispatcheId)
        .get()
        .then(function (docSnap) {
            onSuccess(docSnap.data());
        });
}

export function fetchMerchantProductTraceabilityCode(merchantUserId, traceabilityCode, onSuccess) {
    firebase.firestore().collection('merchant_dispatches').doc(merchantUserId).collection('dispatches').where('traceabilityCode', '==', traceabilityCode)
        .get()
        .then(function (querySnap) {
            if (querySnap.docs.length > 0)
                onSuccess(querySnap.docs[0].data());
            else onSuccess(null);
        });
}

export function fetchMerchantCultiveTraceability(merchantUserId, cultiveId, onSuccess) {
    let latestDispatchDate = new Date()
    latestDispatchDate.setDate(latestDispatchDate.getDate() - 30);

    firebase.firestore().collection('merchant_dispatches')
        .doc(merchantUserId)
        .collection('dispatches')
        .where('merchantCultiveId', '==', cultiveId)
        .where('dispatchDate', '>', dateHelper.isoDateString(latestDispatchDate))
        .get()
        .then(function (querySnap) {
            if (querySnap.docs.length > 0)
                onSuccess(querySnap);
            else onSuccess(null);
        });
}